export default __webpack_public_path__ + "static/white_logo-81a4a1a151b656bbc38a91f9710b3db8.svg";